import React from "react";
import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";
import { CountdownTimer } from "./CountdownTimer";
import { ScarcityBar } from "./ScarcityBar";
export function FinalCta() {
  return <section className="w-full bg-[#3d2b30] px-5 py-16 text-white" data-id="element-64" data-mp="19fqmbsws7ldo">
      <div className="mx-auto max-w-xl text-center" data-id="element-65" data-mp="15cuaqm5nspj8">
        <Reveal data-id="element-66" data-mp="15c2f5bc2arsy">
          <h2 className="font-serif-display text-2xl font-semibold leading-snug sm:text-3xl" data-id="element-67" data-mp="15fq7i75rt863">
            🌿 Imagina cómo te sentirás en solo 7 días…
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-[#e7c9d1] sm:text-base" data-id="element-68" data-mp="1edipjj2vmtx6">
            Sosteniendo en tus manos una colección de sales de baño creada por ti. Con una marca
            que lleva tu nombre. Con productos listos para mostrar, regalar o vender.
          </p>
          <p className="mt-5 font-serif-display text-xl italic text-[#f0dbe1]" data-id="element-69" data-mp="224o47ux2zg5w">
            “Lo logré. Esta es mi propia línea de sales de baño.”
          </p>
          <p className="mt-5 text-sm text-[#e7c9d1]" data-id="element-70" data-mp="n5m6o3b5462e">
            Hoy puede ser el día en que dejes de imaginarlo y empieces a construirlo.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-10" data-id="element-71" data-mp="s4xolfn8thlk">
          <div className="rounded-3xl bg-white p-6 text-[#3d2b30] sm:p-8" data-id="element-72" data-mp="x3915y4xa67h">
            <p className="text-xs font-bold uppercase tracking-widest text-[#a04a63]" data-id="element-73" data-mp="122vd8490lgep">
              Crea tu línea por solo
            </p>
            <p className="mt-1 font-serif-display text-5xl font-bold text-[#a04a63] sm:text-6xl" data-id="element-74" data-mp="163f9z6poei0b">
              $12,99 <span className="text-2xl" data-id="element-75" data-mp="1b2i6u3vi5hx7">USD</span>
            </p>
            <p className="mt-2 text-xs text-[#6b565b]" data-id="element-76" data-mp="1fujpc7j9k4vo">
              El cambio de moneda se realiza automáticamente en el checkout.
            </p>

            <div className="mt-6" data-id="element-77" data-mp="1kstmgnojtfjx">
              <ScarcityBar data-id="element-78" data-mp="1psfyitsn4pr5" />
            </div>

            <div className="mt-6" data-id="element-79" data-mp="1ptr0co2iznfm">
              <CtaButton data-id="element-80" data-mp="1pqd0bmhc3qbc">✨ Quiero empezar hoy ✨</CtaButton>
            </div>

            <div className="mt-5" data-id="element-81" data-mp="1tukmbbweqs5v">
              <CountdownTimer data-id="element-82" data-mp="3quow0r7donna" />
            </div>

            <p className="mt-5 text-xs font-semibold text-[#6b565b]" data-id="element-83" data-mp="3qvgty8og6xgq">
              Descarga inmediata · Pago único · Acceso de por vida · Garantía de 7 días
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}